import { Button, withStyles } from '@material-ui/core';

export default withStyles(() => ({
  root: {
    color: '#1d9ad0',
  },
}))(Button);
